export default "__VITE_ASSET__CD0Zl$NH__";